export const test = 'test';
export const dateFormat = 'DD.MM.yyyy';
export const reportValidDays = 14;
